<template>
  <basic-container>
    <el-form ref="searchForm" :model="query" label-width="100px" margin-top="0" :rules="rules">
      <el-row>
        <el-col :span="5">
          <el-form-item label="工单编号" prop="wordId">
            <el-input v-model="query.wordId" placeholder="工单编号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="小区名称" prop="areaId">
            <el-select
              v-model="query.areaId"
              placeholder="请选择小区"
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in allPropertyList"
                :key="item.id"
                :label="item.objectFullName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="环节" prop="complaintParentStatus">
            <el-select
              v-model="query.complaintParentStatus"
              placeholder="环节"
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in allComplaintStatusList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="类型" prop="type">
            <el-select v-model="query.type" placeholder="类型" style="width: 100%" clearable>
              <el-option
                v-for="item in allTypeList"
                :key="item.id"
                :label="item.typeName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="紧急程度" prop="isExigency">
            <el-select
              v-model="query.isExigency"
              placeholder="紧急程度"
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in allExigencyList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col span="24" class="avue-form__menu avue-form__menu--center">
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
            @click.prevent="submitSearchForm"
            >搜索
          </el-button>
          <el-button type="white" @click="searchReset" icon="el-icon-delete">清空</el-button>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
      @row-dblclick="handleRowDBLClick"
    >
      <template slot="isExigency" slot-scope="scope">
        <el-tag v-show="scope.row.isExigency == 1">紧急</el-tag>
        <el-tag type="danger" v-show="scope.row.isExigency == 2">特急</el-tag>
        <el-tag type="info" v-show="scope.row.isExigency == 0">一般</el-tag>
      </template>
      <template slot="complaintParentStatus" slot-scope="scope">
        <el-tag type="danger" v-show="scope.row.complaintParentStatus == 1">登记</el-tag>
        <el-tag type="danger" v-show="scope.row.complaintParentStatus == 2">受理</el-tag>
        <el-tag type="success" v-show="scope.row.complaintParentStatus == 3">处理</el-tag>
        <el-tag type="success" v-show="scope.row.complaintParentStatus == 4">核验</el-tag>
        <el-tag type="warning" v-show="scope.row.complaintParentStatus == 5">完成</el-tag>
      </template>
      <template slot="complaintSubStatus" slot-scope="scope">
        <el-tag>{{ showResult(scope.row) }}</el-tag>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" icon="el-icon-edit" @click="openDrawer(scope.row.id)"
          >查 看</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          @click="openRepairLogDialog(scope.row.id, scope.row.wordId)"
          >历 程
        </el-button>
      </template>
    </avue-crud>
    <!--    查看弹出框-->
    <el-drawer
      :visible.sync="drawerFlag"
      :before-close="handleDrawerClose"
      :append-to-body="true"
      size="70%"
    >
      <avue-form
        v-if="drawerFlag"
        ref="manageOptionFormRef"
        v-model="manageOptionForm"
        :option="_option"
        :upload-preview="uploadPreview"
      >
        <template slot="repairDesc" slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="manageOptionForm.repairDesc"
            placement="top-start"
          >
            <el-input
              v-model="manageOptionForm.repairDesc"
              :disabled="areaFlag"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-tooltip>
        </template>
        <template slot="address" slot-scope="scope">
          <el-input
            placeholder="请输入详细地址"
            v-model="manageOptionForm.address"
            :disabled="propertyFlag"
            class="input-with-select"
          >
          </el-input>
        </template>
        <template slot="materials" slot-scope="scope">
          <div>
            <avue-crud ref="crud1" :data="priceData" :option="repairPriceOption"> </avue-crud>
            <el-row>
              <el-col span="4">
                <el-form-item label="总金额">
                  <el-input disabled="true" v-model="totalAmount"></el-input>
                </el-form-item>
              </el-col>
              <el-col span="4">
                <el-form-item label="支付方式">
                  <el-select
                    v-model="manageOptionForm.payType"
                    placeholder="请选择"
                    style="width: 100%"
                    clearable
                    :disabled="processDeptFlag"
                  >
                    <el-option label="微信" :value="2"></el-option>
                    <el-option label="支付宝" :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </template>
        <template slot="repairTypeId" slot-scope="scope">
          <el-select
            v-model="manageOptionForm.repairTypeId"
            placeholder="请选择反应类型"
            style="width: 100%"
            clearable
            :disabled="repairTypeFlag"
          >
            <el-option
              v-for="item in allTypeList"
              :key="item.id"
              :label="item.typeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </template>
        <template slot="areaId" slot-scope="scope">
          <el-select
            v-model="manageOptionForm.areaId"
            placeholder="请选择小区"
            style="width: 100%"
            clearable
            :disabled="areaFlag"
          >
            <el-option
              v-for="item in allPropertyList"
              :key="item.id"
              :label="item.objectFullName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </template>
        <template slot="processDeptId" slot-scope="scope">
          <el-select
            v-model="manageOptionForm.processDeptId"
            placeholder="处理部门"
            style="width: 100%"
            :disabled="processDeptFlag"
          >
            <el-option
              v-for="(item, index) in allDeptList"
              :key="index"
              :label="item.title"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>
        <template slot="visitType" slot-scope="scope">
          <el-select
            v-model="manageOptionForm.visitType"
            placeholder="核验形式"
            style="width: 100%"
            :disabled="visitTypeFlag"
          >
            <el-option
              v-for="(item, index) in allVisitTypeList"
              :key="index"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="menuForm">
          <el-button plain type="primary" icon="el-icon-view" @click="openRepairLogDialog(1)"
            >历 程
          </el-button>
        </template>
      </avue-form>
    </el-drawer>
    <!--    流程弹窗-->
    <repairLog ref="repairLog"></repairLog>
  </basic-container>
</template>

<script>
  import { add, getCommunity, getDetail, queryPage, remove, update } from '@/api/v4ward/repair/repairinfo';
import repairOption from './repair-option2';
import repairAddOption from './repair-add-option2';
import repairManageOption from './repair-manage-option2';
import repairVisitOption from './repair-visit-option';
import { mapGetters } from 'vuex';
import { getOptionNode } from '@/api/v4ward/property/baseproperty';
import { getDictionary, selectDept } from '@/api/common';
import repairLog from '@/views/v4ward/repairlog/repairlogshow';
import repairPriceOption from './repair-cost-price';
import { selectAllType, selectType } from '@/api/v4ward/repairtype/repairtype';

export default {
  components: { repairLog },
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      //新增
      repairAddOption: repairAddOption,
      //处理
      repairManageOption: repairManageOption,
      //核验
      repairVisitOption: repairVisitOption,
      //物料明细
      repairPriceOption: repairPriceOption,

      selectionList: [],
      option: repairOption,
      allPropertyList: [],
      allComplainTypeList: [],
      allComplaintStatusList: [],
      allExigencyList: [],
      allVisitTypeList: [],
      allDeptList: [],
      data: [],
      priceData: [],
      manageOption: [],
      allTypeList: [],
      allPowerTypeList:[],

      manageOptionForm: {},
      areaFlag: false,
      processDeptFlag: false,
      visitTypeFlag: false,
      drawerFlag: false,
      propertyFlag: false,
      repairTypeFlag: false,
      readOnly: false,
    };
  },
  created() {
    this.initSelectList();
  },
  computed: {
    _option() {
      var group = {
        submitBtn: false,
        emptyBtn: false,
        group: this.manageOption,
      };
      return group;
    },
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.repairinfo_add, false),
        viewBtn: this.vaildData(this.permission.repairinfo_view, false),
        delBtn: this.vaildData(this.permission.repairinfo_delete, false),
        editBtn: this.vaildData(this.permission.repairinfo_edit, false),
      };
    },
    totalAmount() {
      var a = 0;
      this.priceData.forEach((value, index, array) => {
        a = a + Number(value.num) * Number(value.price);
      });
      return a;
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    showResult(row) {
      if (row.complaintParentStatus == 1) {
        return '登记中';
      } else if (row.complaintParentStatus == 2) {
        return '受理中';
      } else if (row.complaintParentStatus == 3) {
        if (row.processResult == 2) {
          return '处理完成';
        }
        return '处理中';
      } else if (row.complaintParentStatus == 4) {
        if (row.visitResult) {
          return '核验完成';
        }
        return '核验中';
      } else if (row.complaintParentStatus == 5) {
        return '已完成';
      }
    },
    getDate(data) {
      this.priceData = data;
    },
    handleRowDBLClick(row, event) {
      this.openDrawer(row.id);
    },
    handleDrawerClose(hide) {
      this.repairAddOption.label = '登记';
      this.manageOption = [];
      this.manageOptionForm = {};
      this.areaFlag = false;
      this.processDeptFlag = false;
      this.visitTypeFlag = false;
      this.drawerFlag = false;
      hide();
    },
    downloadFile(url) {
      try {
        var i = url.lastIndexOf('//11//');
        var name = url.substring(i+6);
        url = url.slice(0,i);
        console.log(name,url);
        let file_url = url;
        let xhr = new XMLHttpRequest();
        xhr.open("get", file_url, true);
        xhr.responseType = "blob";
        xhr.onload = function () {
          if (this.status === 200) {
            const reader = new FileReader()
            reader.readAsDataURL(this.response);
            reader.onload = function (e) {
              let a = document.createElement('a');
              a.setAttribute("download", name);
              a.style.display = "none";
              a.href = e.target.result;
              a.click();
            };
          }
        };
        xhr.send();
      } catch (e) {
        alert('下载异常！');
      }
    },
    uploadPreview(file, column, done) {
      this.downloadFile(file.url);
    },
    //禁用表单文件上传功能;
    hideFormUploadButton(formStatus, tabStatus) {
      this.$nextTick(() => {
          let el_list = document.querySelectorAll('label[for*="accessoriesStr"]');
          if (el_list.length > 0) {
            el_list.forEach((element, index) => {
              element.parentElement.querySelector('button').style.display = 'none';
              let el_list_ = element.parentElement.querySelectorAll('i[class="el-icon-close"]');
              if (el_list_.length > 0) {
                this.hideFormUploadFileCloseButton(el_list_);
              }
            });
          }
      });
    },
    //禁用表单文件上传删除功能;
    hideFormUploadFileCloseButton(el_list) {
      el_list.forEach((element, index) => {
        element.style.display = 'none';
      });
    },
    changeUploader(formStatus, tabStatus) {
      this.hideFormUploadButton(formStatus, tabStatus);
      return;
    },
    //查看
    openDrawer(id) {
      getDetail({ id: id }).then((data) => {
        this.manageOptionForm = data.data;
        this.priceData = data.data.materials;
        this.manageOptionForm.time = data.data.createTime;
        this.manageOptionForm.userName = data.data.createUserName;
        this.manageOptionForm.range = [
          data.data.appointmentStatusTime,
          data.data.appointmentEndTime,
        ];
        let formStatus = this.manageOptionForm.complaintParentStatus;
        const addOption2 = JSON.parse(JSON.stringify(this.repairAddOption));
        addOption2.column.forEach((value, index, array) => {
          if (value.prop.indexOf('accessoriesStr') != -1) {
          } else {
            value.disabled = true;
          }
        });
        const manageOption1 = JSON.parse(JSON.stringify(this.repairManageOption));
        manageOption1.column.forEach((value, index, array) => {
          if (value.prop.indexOf('accessoriesStr') != -1) {
          } else {
            value.disabled = true;
          }
        });
        const visitOption = JSON.parse(JSON.stringify(this.repairVisitOption));
        visitOption.column.forEach((value, index, array) => {
          if (value.prop.indexOf('accessoriesStr') != -1) {
          } else {
            value.disabled = true;
          }
        });
        this.areaFlag = true;
        this.propertyFlag = true;
        this.repairTypeFlag = true;
        this.processDeptFlag = true;
        this.visitTypeFlag = true;
        this.manageOption = [addOption2, manageOption1, visitOption];
        this.handlerHide(this.manageOptionForm.isVisit);
        this.manageOption[0].label = '登记  工单编号：' + this.manageOptionForm.wordId;
        this.drawerFlag = true;
        // if (this.activeName === 'first') {
        setTimeout(() => {
          let _el = document.querySelector(
            'div[id*="el-collapse-content"] > div > div > div:nth-child(13) > div > div > div > div.avue-upload.avue-upload--list.avue-upload--upload > div.el-upload.el-upload--picture-img'
          );
          _el.style.display = 'inline-block';

          _el.addEventListener('click', (e) => {
            setTimeout(() => {
              _el.querySelector('div>div>span>i').style.color = '#fff';
            });
          });
        });
        // }
        this.changeUploader(formStatus, 'first');
      });
    },
    handlerHide(val) {
      var visitTime = this.findObject(this.manageOption[2].column, 'visitTime');
      var visitType = this.findObject(this.manageOption[2].column, 'visitType');
      var satisfaction = this.findObject(this.manageOption[2].column, 'satisfaction');
      if (val === 0) {
        visitTime.display = true;
        visitTime.rules = [
          {
            required: true,
            message: '请选择回访时间',
            trigger: 'blur',
          },
        ];
        visitType.display = true;
        visitType.rules = [
          {
            required: true,
            message: '请选择回访形式',
            trigger: 'blur',
          },
        ];
        satisfaction.display = true;
        satisfaction.rules = [
          {
            required: true,
            message: '请选择满意度',
            trigger: 'blur',
          },
        ];
      } else {
        visitTime.display = false;
        visitTime.rules = [];
        visitType.display = false;
        visitType.rules = [];
        satisfaction.display = false;
        satisfaction.rules = [];
      }
    },
    //历程弹窗
    openRepairLogDialog(id, title) {
      if (id === 1) {
        id = this.manageOptionForm.id;
        title = this.manageOptionForm.wordId;
      }
      this.$refs.repairLog.openRepairLogDialog(id, title);
    },
    initSelectList() {
      getCommunity({}).then((data) => {
        this.allPropertyList = data.data;
      });
      getDictionary('complaint_type').then((data) => {
        this.allComplainTypeList = data.data;
      });
      getDictionary('complaint_status').then((data) => {
        this.allComplaintStatusList = data.data;
      });
      getDictionary('complaint_exigency').then((data) => {
        this.allExigencyList = data.data;
      });
      getDictionary('complaint_visit_type').then((data) => {
        this.allVisitTypeList = data.data;
      });
      selectDept().then((data) => {
        this.allDeptList = data.data;
      });
      selectAllType().then((data) => {
        this.allTypeList = data.data;
      });
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      queryPage(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style scoped>
/deep/.el-drawer__body {
  overflow: scroll !important;
}
/deep/ .el-input.is-disabled .el-input__inner {
  color: black;
}
div.el-form-item__content {
  margin-left: 0;
}
</style>
<style scoped>
.avue-crud__pagination {
  height: 25px;
}
</style>
